import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { imageVariants, textVariants, containerVariants } from '../../script/animationVariants';

// Takım verileri artık isim ve unvan alanları nesne olarak tanımlanmıştır.
const teamData = [
  {
    name: { tr: "Ömer ÇENGEL", en: "Ömer ÇENGEL" },
    image: "/images/hakkimizda/ekip/omer-cengel.jpg",
    title: { tr: ["Yönetim Kurulu Başkanı"], en: ["Chairman of the Board"] },
  },
  {
    name: { tr: "Ali DEMİR", en: "Ali DEMİR" },
    image: "/images/hakkimizda/ekip/ali-demir.jpg",
    title: { tr: ["Yönetim Kurulu Başkan Yardımcısı","Genel Müdür"], en: ["Vice Chairman of the Board","General Manager"] },
  },
  {
    name: { tr: "Emel DEMİR", en: "Emel DEMİR" },
    image: "/images/hakkimizda/ekip/emel-demir.jpg",
    title: { tr: ["Yönetim Kurulu Başkan Yardımcısı"], en: ["Vice Chairman of the Board"] },
  },
  {
    name: { tr: "Emre GÖREN", en: "Emre GÖREN" },
    image: "/images/hakkimizda/ekip/emre-goren.jpg",
    title: { tr: ["Satış Müdürü"], en: ["Sales Manager"] },
  },
  {
    name: { tr: "Orçun ŞAHİN", en: "Orçun ŞAHİN" },
    image: "/images/hakkimizda/ekip/orcun-sahin.jpg",
    title: { tr: ["Metal İşleme Merkezi Müdürü"], en: ["Metal Processing Center Manager"] },
  },
  {
    name: { tr: "Bekir ARSLAN", en: "Bekir ARSLAN" },
    image: "/images/hakkimizda/ekip/bekir-arslan.jpg",
    title: { tr: ["İdari İşler Müdürü","Satış Temsilcisi"], en: ["Administrative Manager","Sales Representative"] },
  },
  {
    name: { tr: "Mehmet ÇAMALAN", en: "Mehmet ÇAMALAN" },
    image: "/images/hakkimizda/ekip/mehmet-camalan.jpg",
    title: { tr: ["Yurtiçi Satış Temsilcisi"], en: ["Domestic Sales Representative"] },
  },
  {
    name: { tr: "Mert ÖZALAN", en: "Mert ÖZALAN" },
    image: "/images/hakkimizda/ekip/mert-ozalan.jpg",
    title: { tr: ["Yurtdışı Satış Temsilcisi"], en: ["International Sales Representative"] },
  },
  {
    name: { tr: "Arif Emre KOYUN", en: "Arif Emre KOYUN" },
    image: "/images/hakkimizda/ekip/arif-emre-koyun.jpg",
    title: { tr: ["Yurt Dışı Satış Temsilcisi"], en: ["International Sales Representative"] },
  },
  {
    name: { tr: "Ömer BOZKURT", en: "Ömer BOZKURT" },
    image: "/images/hakkimizda/ekip/omer-bozkurt.jpg",
    title: { tr: ["Proje Ofis Şefi","IT Uzmanı"], en: ["Project Office Manager","IT Specialist"] },
  },
  {
    name: { tr: "Yasemin ŞAHİN", en: "Yasemin ŞAHİN" },
    image: "/images/hakkimizda/ekip/yasemin-sahin.jpg",
    title: { tr: ["Muhasebe Uzmanı"], en: ["Accounting Specialist"] },
  },
  {
    name: { tr: "Murat ARIOĞLU", en: "Murat ARIOĞLU" },
    image: "/images/hakkimizda/ekip/murat-arioglu.jpg",
    title: { tr: ["Sevkiyat Sorumlusu"], en: ["Shipping Manager"] },
  },
  {
    name: { tr: "Ahmet AYDIN", en: "Ahmet AYDIN" },
    image: "/images/hakkimizda/ekip/ahmet-aydin.jpg",
    title: { tr: ["Proje  Mühendisi"], en: ["Project Engineer"] },
  },
  {
    name: { tr: "Hasan ALPER", en: "Hasan ALPER" },
    image: "/images/hakkimizda/ekip/hasan-alper.jpg",
    title: { tr: ["Proje Mühendisi"], en: ["Project Engineer"] },
  },
  {
    name: { tr: "Melih ÖZLEK", en: "Melih ÖZLEK" },
    image: "/images/hakkimizda/ekip/melih-ozlek.jpg",
    title: { tr: ["Proje Mühendisi"], en: ["Project Engineer"] },
  },

  {
    name: { tr: "Batuhan BOZKURT", en: "Batuhan BOZKURT" },
    image: "/images/hakkimizda/ekip/batuhan-bozkurt.jpg",
    title: { tr: ["Üretim Planlama Şefi"], en: ["Production Planning Manager"] },
  },

 
  {
    name: { tr: "Ferdi GÜL", en: "Ferdi GÜL" },
    image: "/images/hakkimizda/ekip/ferdi-gul.jpg",
    title: { tr: ["Makine Teknikeri"], en: ["Machine Technician"] },
  },



  {
    name: { tr: "Tekincan KARASU", en: "Tekincan KARASU" },
    image: "/images/hakkimizda/ekip/tekincan-karasu.jpg",
    title: { tr: ["Teknik Ressam"], en: ["Technical Draftsman"] },
  },


];

const Section3 = () => {
  // useTranslation hook'u ile t fonksiyonunu ve mevcut dil değerini alıyoruz.
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <motion.div className="col-start-3 col-span-10 my-40">
      {/* Bölüm başlığı: Çeviri dosyasından alınır */}
      <motion.h1 className="text-45 pb-5 font-light">
        {t('section3.teamTitle')}
      </motion.h1>

      {/* Takım üyelerini grid yapısında listeliyoruz */}
      <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-7">
        {teamData.map((member, index) => (
          <motion.div
            key={index}
            
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{
              opacity: 1,
              scale: 1,
              transition: {
                type: "spring",
                stiffness: 100,
                damping: 10,
                delay: index * 0.1,
              },
            }}
          >
           
            <div className="relative">
            <img
              src={member.image}
              alt={member.name[currentLanguage]}
              className="object-contain pb-5"
            />
            {/* <img src='/images/filigran.png' className='absolute top-0 left-0 w-full h-full object-cover'/> */}
            </div>
            <h1 className="text-25">{member.name[currentLanguage]}</h1>
            <div className="leading-tight">
              {member.title[currentLanguage].map((title, titleIndex) => (
                <h2 key={titleIndex} className="text-18 font-light">{title}</h2>
              ))}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default Section3;
